export default __webpack_public_path__ + "static/media/outclient.34bb5dfc.jpg";